"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dogecoinGetAccountPaths = dogecoinGetAccountPaths;
exports.dogecoinNextAccountPath = dogecoinNextAccountPath;
exports.dogecoinGetAddress = dogecoinGetAddress;
exports.dogecoinGetPublicKeys = dogecoinGetPublicKeys;
exports.dogecoinSignTx = dogecoinSignTx;
const metamask_snaps_adapter_1 = require("@shapeshiftoss/metamask-snaps-adapter");
const common_1 = require("./common");
const utxo_1 = require("./utxo");
function dogecoinGetAccountPaths(msg) {
    return (0, utxo_1.utxoGetAccountPaths)(msg);
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function dogecoinNextAccountPath(msg) {
    // Only support one account for now (like portis).
    return undefined;
}
function dogecoinGetAddress(msg) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield (0, metamask_snaps_adapter_1.dogecoinGetAddress)({ snapId: common_1.SNAP_ID, addressParams: msg });
    });
}
function dogecoinGetPublicKeys(msg) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield (0, metamask_snaps_adapter_1.dogecoinGetPublicKeys)({ snapId: common_1.SNAP_ID, addressParams: msg });
    });
}
function dogecoinSignTx(msg) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield (0, metamask_snaps_adapter_1.dogecoinSignTransaction)({ snapId: common_1.SNAP_ID, transaction: msg });
    });
}
//# sourceMappingURL=dogecoin.js.map